// Common field attributes
// =======================

import React, { RefObject } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import FieldSize, { fieldSizePropTypes } from './fieldsize'
import style from './field.module.scss'

export interface FieldProps {
  name?: string
  value: string | number
  type?: string
  size?: keyof typeof FieldSize
  errorMessage?: string
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur: React.EventHandler<any>
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: React.EventHandler<any>
  subLabel?: string
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  classNames?: any
  label?: React.ReactNode
  id?: string
  ariaLabel?: string
  disabled?: boolean
  tooltip?: React.ReactNode
  isHorizontal?: boolean
  innerRef?: RefObject<HTMLElement>
}

export const fieldPropTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  ...fieldSizePropTypes,
  errorMessage: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  subLabel: PropTypes.string,
  classNames: PropTypes.object,
  label: PropTypes.node,
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.node,
  isHorizontal: PropTypes.bool,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    // 'any' instead of instanceOf(Element) to support SSR out of the box
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

export const textfieldPropTypes = {
  ...fieldPropTypes,
  maxLength: PropTypes.number,
  pattern: PropTypes.string,
  autoComplete: PropTypes.string,
  autoCorrect: PropTypes.string,
  placeholder: PropTypes.string,
  showCharacterCount: PropTypes.bool,
  suggestedLength: PropTypes.number,
  step: PropTypes.number,
  inputMode: PropTypes.string,
}

export function makeIdString() {
  return Math.random().toString(36).slice(2)
}

export const makeIdFromName = (name: string): string =>
  name.replace(/[^A-Za-z0-9]/g, '-')

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const wrapIfHorizontal = (opts: any, children: React.ReactNode) =>
  opts.isHorizontal ? (
    <div
      className={classnames(
        style[`horizontal${opts.type}Wrapper`],
        opts.classNames[`horizontal${opts.type}Wrapper`]
      )}
    >
      {children}
    </div>
  ) : (
    children
  )
